import Checkers from "./class/Checkers";
import {fetchPropertyPrice} from "../redux/actions";
import {useSelector} from "react-redux";

export const priceHandler = (dispatch, forList = false, page_id, property_id, priceInitialized, checkin, checkout, priceNeedUpdate, adults, kids) => {
    if(forList){
        return
    }

    // const checkin = useSelector(state => state['propertiesParams']['checkin'])
    // const checkout = useSelector(state => state['propertiesParams']['checkout'])
    // const adults = useSelector(state => state['propertiesParams']['adults'])
    // const kids = useSelector(state => state['propertiesParams']['kids'])

    // const infants = useSelector(state => state['propertiesParams']['infants'])
    // const price = useSelector(state => state['appSettings']['price'])
    // const finalPrice = useSelector(state => state['appSettings']['finalPrice'])
    // const discount = useSelector(state => state['appSettings']['discount'])
    // const hasDiscount = useSelector(state => state['appSettings']['hasDiscount'])
    // const accommondationLength = useSelector(state => state['appSettings']['accommondationLength'])
    // const securityDeposit = useSelector(state => state['appSettings']['securityDeposit'])

    // const dateRangeValid = useSelector(state => state['propertiesParams']['dateRangeValid'])
    // const page_id = useSelector(state => state['propertiesParams']['page_id'])
    // const property_id = useSelector(state => state['propertiesParams']['property_id'])
    //
    // const priceInitialized = useSelector(state => state['appSettings']['priceLoading'])

    if(priceNeedUpdate && Checkers.isValidDate(checkin) && Checkers.isValidDate(checkout)){
        dispatch(fetchPropertyPrice(property_id, page_id, checkin, checkout, adults, kids))
    }

    // return [price, finalPrice, discount, hasDiscount, accommondationLength, securityDeposit]
}

export const generateIquiryUrlHandler = () => {
    const bookingAppUrl = useSelector(state => state['appSettings']['bookingAppUrl'])
    const checkin = useSelector(state => state['propertiesParams']['checkin'])
    const checkout = useSelector(state => state['propertiesParams']['checkout'])
    const adults = useSelector(state => state['propertiesParams']['adults'])
    const kids = useSelector(state => state['propertiesParams']['kids'])
    const infants = useSelector(state => state['propertiesParams']['infants'])
    const bedroomId = useSelector(state => state['appSettings']['bookingBedroomId'])
    const propertySlug = useSelector(state => state['appSettings']['propertySlug'])

    let params = {
        bedroom: bedroomId,
        kids: 0
    }

    if ( Checkers.isValidDate(checkin) ) {
        params['from'] = checkin
    }
    if ( Checkers.isValidDate(checkout) ) {
        params['to'] = checkout
    }
    if ( adults>0 ) {
        params['guests'] = adults
    }
    if ( kids>0 ) {
        params['kids'] += kids
    }
    if ( infants>0 ) {
        params['kids'] += infants
    }

    if(Checkers.isValidString(propertySlug)){
        // @ts-ignore
        return bookingAppUrl + "/en/inquiry-form/"+propertySlug+"?" + new URLSearchParams(params).toString()
    }

    // @ts-ignore
    return bookingAppUrl + "/en/book?" + new URLSearchParams(params).toString()
}

export const generateBookUrlHandler = () => {
    const bookUrl = useSelector(state => state['appSettings']['bookUrl'])
    const roomCode = useSelector(state => state['appSettings']['roomCode'])
    const checkin = useSelector(state => state['propertiesParams']['checkin'])
    const checkout = useSelector(state => state['propertiesParams']['checkout'])
    const adults = useSelector(state => state['propertiesParams']['adults'])
    const kids = useSelector(state => state['propertiesParams']['kids'])
    const infants = useSelector(state => state['propertiesParams']['infants'])
    const wh_direct_checkout = useSelector(state => state['propertiesParams']['whDirectCheckout'])

    if(!Checkers.isValidString(bookUrl)){
        return null
    }

    let url = bookUrl

    let params = {
        room: roomCode
    }

    params['exclusive'] = 1
    if(wh_direct_checkout) {
        params['direct'] = 1
    }
    params['adults'] = 0

    if ( Checkers.isValidDate(checkin) ) {
        params['checkin'] = checkin
    }
    if ( Checkers.isValidDate(checkout) ) {
        params['checkout'] = checkout
    }
    if ( adults>=0 ) {
        params['adults'] = adults
    }
    if ( kids>=0 ) {
        params['children'] = kids
    }
    if ( infants>=0 ) {
        params['infants'] = infants
    }

    return url + (url.includes('?') ? "&" : "?") + new URLSearchParams(params).toString()
}